module.exports = __webpack_public_path__ + "img/Slide5.fb5d4ef6.jpg";